// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { postDeletePaths } from 'helpers/api'

import {
  fetchAndSetProjectCompanies,
  removeMultiplePaths,
} from 'redux/modules/projectSummary'

const deleteSinglePath = () => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { pathDetails } = getState()

      const pathId = pathDetails.get('pathId')
      const projectId = pathDetails.get('projectId')
      const withinProjectSummary = pathDetails.get('withinProjectSummary')

      try {
        const { message } = await postDeletePaths(pathId)

        // if we're within the project summary, then update redux state and remove the path
        if (withinProjectSummary) {
          dispatch(removeMultiplePaths([pathId]))
          await dispatch(fetchAndSetProjectCompanies(projectId))
        }

        // return the response message to the caller
        return message
      } catch (err) {
        // simply throw the error to the caller since
        // it will be different depending on the pathStatusId.
        throw err
      }
    })
  )
)

export default deleteSinglePath
